import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CartItem, IlClass } from '@queries/generated';
import { ILClassService } from '@services/instructor-led/il-class.service';
import { SidebarToggleComponent } from '../sidebar-toggle/sidebar-toggle.component';

@Component({
  selector: 'vnm-checkout-bookable-class-list',
  templateUrl: './checkout-bookable-class-list.component.html',
  styleUrls: ['./checkout-bookable-class-list.component.scss']
})
export class CheckoutBookableClassListComponent implements OnInit {
  @Input() item: CartItem;
  @Input() ilCourseId: number;
  @Output() selectedClass = new EventEmitter<IlClass>();

  bookableClasses$: ReturnType<ILClassService['loadBookableClassesForILCourse']>;

  constructor(private ilClassService: ILClassService, private sidebarToggle: SidebarToggleComponent) {}

  ngOnInit() {
    if (this.ilCourseId) {
      this.bookableClasses$ = this.ilClassService.loadBookableClassesForILCourse(this.ilCourseId, true);
    }
  }

  onSelectClass(ilClass: IlClass) {
    this.selectedClass.emit(ilClass);
  }

  onCloseButtonClick() {
    this.sidebarToggle.close();
  }
}
